// Emoji icons per category slug — shared between mobile and desktop views.
export const CATEGORY_ICONS = {
    snacks: "🍿",
    spices_whole: "🌶️",
    spices_powder: "🧂",
    lentils: "🫘",
    rte: "🍱",
    sweets: "🍬",
    packed_food: "📦",
    rice: "🍚",
    soap: "🧼",
    moisturizer: "🧴",
    pickles: "🥒",
    pooja_needs: "🪔",
    flour: "🌾",
    rtc: "🍳",
    fats: "🧈",
    perfumes_and_toilet_waters: "🌸",
    sunscreen: "☀️",
    hair_oil: "💆",
    hair_color: "🎨",
    tea: "🍵",
    pain_releif: "💊",
    beans: "🫘",
    produce: "🥬",
    dairy: "🥛",
    bakery: "🥖",
    beverages: "🥤",
    meat: "🍖",
    pantry: "🌾",
    beauty: "💄",
    medicine: "💊",
};

// Categories that are not yet stocked but we want to advertise.
// (Now replaced by the parent-category layer in `parentCategories.js`. Kept
// here only for backwards compatibility — safe to delete once we're sure
// nothing imports it.)
export const WISHLIST_CATEGORIES = [];

export const labelFor = (c, t) => {
    if (!c) return "";
    const translated = t(c.name_key);
    if (translated && translated !== c.name_key) return translated;
    return c.label || c.id.replace(/_/g, " ");
};
